module.exports = __webpack_public_path__ + "zvetseni-prsou_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_5_after.jpg
// module id = 1355
// module chunks = 0